module.exports = __webpack_public_path__ + "img/logo_flypayloan.1b741402.png";